import { create } from "zustand";
import type { Settings } from "@ebook/contracts";

export type Locale = Settings["locale"];

type LocaleState = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  resetLocale: () => void;
};

export const defaultLocale: Locale = "th";

export const useLocaleStore = create<LocaleState>((set) => ({
  locale: defaultLocale,
  setLocale: (locale) => set({ locale }),
  resetLocale: () => set({ locale: defaultLocale }),
}));
